import { useContext } from "react"
import { IndividualReportFiltersContext } from "../../contexts/IndividualReportFilters.context"

const useIndividualReportFiltersContext = () => {
  const data = useContext(IndividualReportFiltersContext)
  return data
}

export default useIndividualReportFiltersContext
